import { customColors, defaultColors } from '../tokens';
import { colorOpacity } from '../utils';

const primary = '#072AC8';
export const dark = {
  primary: primary,
  //secondary: '#8882F1',
  primaryNavBarBg: '#1f1f1f',
  secondaryNavBarBg: customColors.gray['300'],

  cardBg: '#1f1f1f',
  componentBorder: customColors.gray['300'],
  chartGridColor: customColors.gray['300'],

  selectedMenuBg: customColors.gray['400'],
  selectedSideNavMenuBg: colorOpacity(primary, 0.07),
  menuColor: customColors.gray['50'],

  tableSelectedRowBg: customColors.blue['400'],
  tableHeader: customColors.gray['50'],
  tableHeaderBg: customColors.gray['300'],
  tableRowBorder: defaultColors.whiteAlpha['400'],

  edit: customColors.green['300'],
  delete: customColors.red['500'],
  add: primary,
  cancel: 'gray.300',
  critical: defaultColors.red['500'],
  high: 'orange',
  medium: defaultColors.orange['500'],
  low: defaultColors.yellow['500'],
  info: defaultColors.green['300'],
  hover: '#ebf8ff',
  success: defaultColors.green['300'],
  error: defaultColors.red['500'],

  formFieldBorder: customColors.gray['200'],
  placeholder: customColors.gray['250'],

  pieChartBorder: customColors.gray['100'],
  gaugeChartBorder: customColors.gray['400'],
};
